import authType from '@/store/type/authType'
import configType from '@/store/type/configType'
import Cookies from 'js-cookie'

const JWT_KEY = 'jwt'
const REFRESH_TOKEN_KEY = 'refresh'
const CONFIG_KEY = 'config'
const TRANSLATION_KEY = 'translations'

const storeItem = (key, value, persistent) => {
    const options = {
        sameSite: 'Lax',
    }

    if (persistent) {
        options.expires = 30
    }

    Cookies.set('ordit.' + key, value, options)
}

const getItem = (key) => Cookies.get('ordit.' + key)

const deleteItems = (...keys) => {
    const options = {
        sameSite: 'Lax',
    }

    keys.forEach((key) => {
        Cookies.remove('ordit.' + key, options)
    })
}

const storeLargeItem = (key, value) => {
    localStorage.setItem('ordit.' + key, JSON.stringify(value) || value)
}

const getLargeItem = (key) => {
    const value = localStorage.getItem('ordit.' + key)
    return JSON.parse(value) || value
}

const populateStore = (store) => {
    const jwt = getItem(JWT_KEY)

    if (jwt) {
        store.dispatch(authType.actions.LOGIN_WITH_JWT, jwt)
    }

    const refreshToken = getItem(REFRESH_TOKEN_KEY)

    if (refreshToken) {
        store.dispatch(authType.actions.SET_REFRESH_TOKEN, refreshToken)
    }

    const configCache = getLargeItem(CONFIG_KEY)

    if (configCache) {
        store.commit(configType.mutations.SET_CONFIG_CACHE, configCache)
    }

    const translationsCache = getLargeItem(TRANSLATION_KEY)

    if (translationsCache) {
        Object.keys(translationsCache).map((key) =>
            store.commit(configType.mutations.SET_TRANSLATIONS_CACHE, {
                key,
                translations: translationsCache[key],
            })
        )
    }
}

const credentialPersister = (store) => {
    populateStore(store)
    store.subscribe((mutation, state) => {
        if (mutation.type === authType.mutations.SET_JWT) {
            storeItem(JWT_KEY, state.auth.jwt, state.auth.keepMeSignedIn)
        }

        if (mutation.type === authType.mutations.SET_REFRESH_TOKEN) {
            storeItem(
                REFRESH_TOKEN_KEY,
                state.auth.refreshToken,
                state.auth.keepMeSignedIn
            )
        }

        if (mutation.type === configType.mutations.SET_CONFIG_CACHE) {
            storeLargeItem(CONFIG_KEY, mutation.payload, true)
        }

        if (mutation.type === configType.mutations.SET_TRANSLATIONS_CACHE) {
            storeLargeItem(
                TRANSLATION_KEY,
                state.config.translationsCache,
                true
            )
        }

        if (mutation.type === authType.mutations.LOGOUT) {
            deleteItems(JWT_KEY, REFRESH_TOKEN_KEY)
        }
    })
}

export default credentialPersister
